import { fetchAgg } from '../../../../common/utils/fetch-agg';
import { getThirdPartyFilterOptionsQuery, GQL_OPERATION_NAME } from './query';

export type ThirdPartyFilterValue = {
	name: string;
	label?: string | null;
};

export type ThirdPartyDynamicFilter = {
	name: string;
	values: ThirdPartyFilterValue[];
};

export type ThirdPartyFilterOptionsPayload = {
	filters: ThirdPartyDynamicFilter[];
};

type ThirdPartyFilterOptionsResponse = {
	search?: {
		configuration?: {
			thirdPartyFilterOptions?: ThirdPartyFilterOptionsPayload | null;
		} | null;
	} | null;
};

type ThirdPartyFilterOptionsVariables = {
	cloudId: string;
	datasourceId: string;
	orgId: string | null;
};

export interface ThirdPartyFilterOptionsProps {
	cloudId: string;
	datasourceId: string;
	/** When set, ai-3p-connector can skip an org lookup (faster custom-filters response). */
	orgId?: string;
	aggAbsoluteUrl?: string;
}

/** Fetches available filter options for a third-party datasource from the aggregator. */
export const getThirdPartyFilterOptions = async ({
	cloudId,
	datasourceId,
	orgId,
	aggAbsoluteUrl,
}: ThirdPartyFilterOptionsProps): Promise<ThirdPartyFilterOptionsPayload | null> => {
	try {
		const response = await fetchAgg<
			ThirdPartyFilterOptionsVariables,
			ThirdPartyFilterOptionsResponse
		>({
			graphQuery: getThirdPartyFilterOptionsQuery(),
			variables: {
				cloudId,
				datasourceId,
				orgId: orgId != null && orgId !== '' ? orgId : null,
			},
			operationName: GQL_OPERATION_NAME,
			aggAbsoluteUrl,
		});

		const filterOptions = response.data?.search?.configuration?.thirdPartyFilterOptions ?? null;

		if (response.errors?.length) {
			console.warn(
				`[${GQL_OPERATION_NAME}] GraphQL errors for datasource "${datasourceId}":`,
				response.errors,
			);

			if (!filterOptions) {
				throw new Error(
					`[${GQL_OPERATION_NAME}] GraphQL errors prevented loading third-party filter options for datasource "${datasourceId}"`,
				);
			}
		}

		return filterOptions;
	} catch (error) {
		console.error(
			`[${GQL_OPERATION_NAME}] Failed to fetch third-party filter options for datasource "${datasourceId}":`,
			error,
		);
		throw error;
	}
};
